import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { themeGet } from "sprout-ui-theme";
import { Text } from "sprout-ui-primitives";
import { Search } from "sprout-ui-icons";
const SearchButton = styled(Button)`
  display: inline-flex;
  align-items: center;

  width: 100%;
  height: 36px;
  padding: 0 16px 0 12px;

  border-radius: 30px;

  color: ${themeGet("colors.black.54")};
  background: ${themeGet("colors.grey.100")};
`;
const AppBarSearchButton = (props)=>{
    const { onClick  } = props;
    return /*#__PURE__*/ _jsxs(SearchButton, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx(Search, {}),
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                fontSize: 2,
                pl: "8px",
                children: "Search"
            })
        ]
    });
};
export default AppBarSearchButton;
